import { jsx as _jsx } from "react/jsx-runtime";
import Notification from '../../../../notification';
export const ValidationNotification = () => {
    return _jsx(Notification, { variant: "error", title: "Niet alle velden zijn correct ingevuld" });
};
